import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { JobType } from '../types/JobType';
import style from './JobHistory.module.css';
import Paragraph from './UI/Paragraph';

/**
 * ## Show a job entry
 * Displays a title, a company, a year and an optional description
 * @param {JobType} job
 * @returns
 */
function Job({ job, icon }: { job: JobType; icon: IconDefinition }) {
  return (
    <div className="col-lg-6 m-15px-tb">
      <ul className={style.resumeBox}>
        <li className={style.jobItem}>
          <span className={style.icon}>
            <FontAwesomeIcon icon={icon} data-testid="icon" />
          </span>
          <span className={`${style.time} open-sans-font text-uppercase`}>
            <FormattedMessage id={job.year} />
          </span>
          <h5 className="text-uppercase">
            <FormattedMessage id={job.title} />
            {job.company && (
              <span className={`${style.place} open-sans-font`}>
                <FormattedMessage id={job.company} />
              </span>
            )}
          </h5>
          {job.description && (
            <Paragraph css="multiline" translationId={job.description} />
          )}
        </li>
      </ul>
    </div>
  );
}

export default Job;
